import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NewContactRequest } from './new-contact-request';
import { environment } from '@morningstar/shared/environment';
import { GenericErrorHandler } from '@morningstar/shared/base/error-handler';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SplashPageService {

  constructor(private httpClient: HttpClient) { }

  newContactRequest(request: NewContactRequest): Observable<any> {
    return this.httpClient.post(`${environment.spaceGeekUrl}${environment.api.contactUs}`, request)
                          .pipe(catchError(GenericErrorHandler.handleError<any>('newContactUsRequest')));
  }
}
